import { frontDoor } from '../../../front-door/config'
import { searchAllOnce } from './data'
import { hitTag, resolveLink } from './shape'

// The Ctrl+K window's search for Nateva (lib/search.ts reads this export from the instance's surface-apps
// module): the same database search the front page box uses, so the two always agree.

export type PaletteHit = { key: string; app: string; appLabel: string; title: string; subtitle?: string; href: string }

export async function natevaSearchProvider(query: string, signal: AbortSignal, client: unknown): Promise<PaletteHit[]> {
  const hits = await searchAllOnce(client, query, signal)
  return hits.flatMap((h, i) => {
    const dest = resolveLink(h.link, frontDoor.domain)
    if (!dest) return []
    return [{ key: `nateva:${h.kind}:${i}:${h.link}`, app: h.app, appLabel: hitTag(h), title: h.title, subtitle: h.sub, href: dest.href }]
  })
}
